export default{
    filialpadrao: {
        idcliente       : null,//id do cliente no sac
        idclientepadrao : null,//cliente padrão pra emissão dos pedidos
        codfil          : null,
        descfil         : '',
        fantasia        : '',
        nomecliente     : '',
        idplano         : null,
        tipoplano       : 0,
        descplano       : '',
        idtabela        : null,
        percentrada     : 0,
        permitedesconto : 0,
        formulacustopro : '',
        logo            : '',
        idestoque       : null,
        descestoque     : ''
    },
    usuario: {
        id          : null,
        nome        : '',
        foto        : '',
        descgrupo   : '',
        idclientesac: null,
        dbcliente   : '',
        sistema     : '',
        adrsrv      : '',
        todasfiliais: null,
        idvendedor  : null,
        nomevendedor: '',
        descontoprodutos : 0,
        descontoprodutosprazo : 0,
        descontoservicos : 0,
        descontojuros    : 0,
        descontomulta    : 0,
        cardresumopedidos: 0,
        cardfinanceiro   : 0,
        cardrecursos : 0,
        cardvendedores   : 0,
        cardcompra       : 0,
        definirsenhalogin: 0,
        limitecreditoautorizar: 0,
        receberinfsistema: 0,
        estoquegeralconsultas: 0  
    },
    configpaths: {
        // pathcontrole    : 'https://www.rillsoft-app.cloud/controller/',
        // pathselect2     : 'https://www.rillsoft-app.cloud/controller/select2remoto.php',
        // pathselect2sql  : 'https://www.rillsoft-app.cloud/controller/select2sql.php',
        // pathimagens     : 'https://www.rillsoft-app.cloud/',
        // patharquivos    : 'https://www.rillsoft-app.cloud/',
        pathcontrole    : '',
        pathselect2     : '',
        pathselect2sql  : '',
        pathimagens     : '',
        patharquivos    : '',         
        pathconferencias: 'arquivos/manager/conferencias/',                        
        pathretornos    : 'arquivos/manager/retornos/',        
        pathofx         : 'arquivos/manager/ofx/',
        pathimgprodutos : 'imagens/manager/produtos/',
        pathimgpedidos  : 'imagens/manager/pedidos/',
        pathimgfiliais  : 'imagens/manager/filiais/',
        pathimgclientes : 'imagens/manager/clientes/',
        pathimgusuarios : 'imagens/manager/usuarios/',
        pathcertificados: 'arquivos/manager/certificados/',
        pathtarefas     : 'arquivos/manager/tarefas/'
    },
    perfilusuario:[],
    consultaprodutos:{
        abrirtela    : false
    },
    listaprodutosretornoconsulta:{
        lstprod      : []
    },
    produtoretornoconsulta: {
        idproduto    : null
    },
    consultaclientes:{
        abrirtela    : false
    },
    clienteretornoconsulta: {
        idcliente    : null
    },
    consultafornecedores:{
        abrirtela    : false
    },
    fornecedorretornoconsulta: {
        idfornecedor    : null
    },    
    consultapedidos:{
        abrirtela    : false
    },
    pedidoretornoconsulta: {
        idpedido    : null
    },        
    sidenav:{
        fechar : false
    },
    retornobaixareceber:{
        retorno : 0// 0 - Aguardando, 1 - Baixa realizada
    },
    retornobaixapagar:{
        retorno : 0// 0 - Aguardando, 1 - Baixa realizada
    },    
    consultatituloscob:{
        abrirtela    : false
    },
    tituloscobretornoconsulta: {
        lsttituloscobret : []
    },
    rotinatarefas:{
        abrirtela    : false
    },
    atzcoletor:{
        atualizar : false,
        itenscoletor: []
    },
    verificalib:{
        verificar : false
    }           
}